import './preprocessStars';
import { memo } from 'react';
import { parallax } from '@immutabl3/alchemy/three';
import { useStore } from '@immutabl3/store/react';
import { useAsset } from '@artica/assets';

import animation from './star.animation.json';

const LandscapeStar = memo(function LandscapeStar({
  geometry,
  material,
  position,
}) {
  return (
    <parallax.points
      beaker="chapter1"
      animation={ animation }

      geometry={ geometry }
      material={ material }
      position={ position }
    />
  );
});

export default function LandscapeStarsContainer() {
  const star1 = useAsset('star1');
  const star2 = useAsset('star2');
  const loaded = useStore(['loaded']);

  // NOTE: this is what's causing the light show
  // before rendering the tilescape / landscape
  if (!loaded) return null;

  return (
    <>
      <LandscapeStar { ...star1 } />
      <LandscapeStar { ...star2 } />
    </>
  );
};